import { Platform, type ViewStyle } from 'react-native';

export type LayoutDirection = 'ltr' | 'rtl';

/** Native only — RN Web rejects View `direction` (use syncWebDocumentDirection + webViewDirProps). */
export function viewLayoutDirection(dir: LayoutDirection): ViewStyle {
  return { direction: dir };
}

export function syncWebDocumentDirection(isRTL: boolean): void {
  if (Platform.OS !== 'web' || typeof document === 'undefined') {
    return;
  }
  const dir: LayoutDirection = isRTL ? 'rtl' : 'ltr';
  document.documentElement.setAttribute('dir', dir);
  document.body?.setAttribute('dir', dir);
}

/** LTR flex shells inside Arabic layout — HTML `dir`, not StyleSheet `direction`. */
export function webViewDirProps(dir: LayoutDirection): { dir?: LayoutDirection } {
  if (Platform.OS !== 'web') {
    return {};
  }
  return { dir };
}

/** Native RTL: same LTR isolation as before (View `direction` is valid on iOS/Android). */
export function nativeLtrIsolationStyle(isRTL: boolean): ViewStyle {
  if (!isRTL || Platform.OS === 'web') {
    return {};
  }
  return viewLayoutDirection('ltr');
}
